<script setup lang="ts">
import Social from '~/components/menu/Social.vue';
import type { SocialItem } from '~/types';
import { RedirectConfig } from '~/configs';

const socialItems: SocialItem[] = [
  { icon: 'facebook', href: RedirectConfig.facebook },
  { icon: 'linkedin', href: RedirectConfig.linkedIn },
  { icon: 'instagram', href: RedirectConfig.instagram },
];
</script>

<template>
  <footer class="pb-20 pt-12 sm:pb-24 sm:pt-14">
    <CommonContainer>
      <nav
        class="flex flex-wrap justify-center gap-x-12 gap-y-3 pt-8 sm:pt-10"
        aria-label="Footer"
      >
        <BaseLink
          v-for="{ id, label, link } in LEGAL_NAVIGATION"
          :key="id"
          :link
          class="self-center no-underline"
        >
          {{ label }}
        </BaseLink>
      </nav>
      <Social
        class="mt-7 gap-x-10 justify-center items-center"
        :items="socialItems"
        global-classes="!w-6 xs:!w-8 hd:!w-6 fhd:!w-8 !h-6 xs:!h-8 hd:!h-6 fhd:!h-8"
      />
      <p class="mt-7 text-center text-default-sm xs:text-lg hd:text-md mac:text-default-sm fhd:text-md 4k:text-lg">
        Copyright © {{ new Date().getFullYear() }} Healistic Group Ltd (company number: 13900074) - All Rights Reserved - Registered in England and Wales - 20-22 Wenlock Road, N1 7GU, London, UK
        <!-- Copyright © {{ new Date().getFullYear() }} Healistic Group Ltd. - All Rights Reserved -->
      </p>
    </CommonContainer>
  </footer>
</template>

<!-- <script setup lang="ts"> -->
<!-- import Social from '~/components/menu/Social.vue'; -->
<!-- import type { SocialItem } from '~/types'; -->
<!-- import { RedirectConfig } from '~/configs'; -->

<!-- const socialItems: SocialItem[] = [ -->
<!--  { icon: 'facebook', href: RedirectConfig.facebook }, -->
<!--  { icon: 'linkedin', href: RedirectConfig.linkedIn }, -->
<!--  { icon: 'instagram', href: RedirectConfig.instagram }, -->
<!-- ]; -->
<!-- </script> -->

<!-- <template> -->
<!--  <footer class="pb-20 pt-12 sm:pb-24 sm:pt-14"> -->
<!--    <CommonContainer> -->
<!--      <div class="flex justify-between"> -->
<!--        <CommonLogo class="!w-[45%]" /> -->
<!--        <div class="flex flex-col justify-end gap-y-4"> -->
<!--          <NuxtLink -->
<!--            :to="RedirectConfig.prescriberWebappSignup" -->
<!--            class="w-full" -->
<!--            target="_blank" -->
<!--          > -->
<!--            <BaseButton -->
<!--              style-type="orange" -->
<!--              class="w-full" -->
<!--            > -->
<!--              Doctor Sign Up -->
<!--            </BaseButton> -->
<!--          </NuxtLink> -->

<!--          <NuxtLink -->
<!--            :to="RedirectConfig.customerWebapp" -->
<!--            target="_blank" -->
<!--          > -->
<!--            <BaseButton style-type="outline"> -->
<!--              Patient mobile app -->
<!--            </BaseButton> -->
<!--          </NuxtLink> -->
<!--        </div> -->
<!--      </div> -->
<!--      <div class="inline-flex w-full justify-between align-bottom pt-36"> -->
<!--        <Social -->
<!--          class="gap-x-10 justify-center" -->
<!--          :items="socialItems" -->
<!--        /> -->
<!--        <nav -->
<!--          class="inline-flex flex-wrap justify-center items-center gap-x-16" -->
<!--          aria-label="Footer" -->
<!--        > -->
<!--          <BaseLink -->
<!--            v-for="{ id, label, link } in LEGAL_NAVIGATION" -->
<!--            :key="id" -->
<!--            :link -->
<!--            class="self-center text-white underline underline-offset-2" -->
<!--          > -->
<!--            {{ label }} -->
<!--          </BaseLink> -->
<!--        </nav> -->
<!--        <p class="cursor-default text-center text-default-sm xs:text-lg hd:text-md mac:text-default-sm fhd:text-md 4k:text-lg"> -->
<!--          Copyright © {{ new Date().getFullYear() }} HEALISTIC - All Rights Reserved -->
<!--        </p> -->
<!--      </div> -->
<!--    </CommonContainer> -->
<!--  </footer> -->
<!-- </template> -->
